export enum ActivityObjectTypes {
  START_SCREEN = 'START_SCREEN',
  ENTRY_SURVEY = 'ENTRY_SURVEY',
  VIDEO = 'VIDEO',
  QUESTION = 'QUESTION',
  EXIT_SURVEY = 'EXIT_SURVEY',
  RESULTS_SCREEN = 'RESULTS_SCREEN',
}
